module.exports = __webpack_public_path__ + "static/media/network-hub.6acf5a32.png";